"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setColourAttributeForSnapElement(snapElement, colourAttributes) {
    snapElement.attr({
        fill: colourAttributes.fillColour,
        stroke: colourAttributes.strokeColour,
        strokeWidth: colourAttributes.strokeSize,
    });
}
exports.setColourAttributeForSnapElement = setColourAttributeForSnapElement;
